import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { internalSelectionMenuInjectionKey as y } from "./interface.js";
import M from "../../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { render as O } from "../../../_utils/vue/render.js";
import { mergeEventHandlers as g } from "../../../_utils/vue/merge-handlers.js";
import P from "../../icon/src/Icon.js";
import S from "../../icons/Checkmark.js";
import { defineComponent as $, inject as w, h as c } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { Transition as F } from "../../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
function j(n, o) {
  return c(F, {
    name: "fade-in-scale-up-transition"
  }, {
    default: () => n ? c(P, {
      clsPrefix: o,
      class: `${o}-base-select-option__check`
    }, {
      default: () => c(S)
    }) : null
  });
}
const H = $({
  name: "NBaseSelectOption",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup(n) {
    const {
      valueRef: o,
      pendingTmNodeRef: l,
      multipleRef: u,
      valueSetRef: h,
      renderLabelRef: r,
      renderOptionRef: s,
      labelFieldRef: m,
      valueFieldRef: p,
      showCheckmarkRef: b,
      nodePropsRef: k,
      handleOptionClick: N,
      handleOptionMouseEnter: d
    } = w(y), f = M(() => {
      const {
        value: t
      } = l;
      return t ? n.tmNode.key === t.key : !1;
    });
    function e(t) {
      const {
        tmNode: i
      } = n;
      i.disabled || N(t, i);
    }
    function a(t) {
      const {
        tmNode: i
      } = n;
      i.disabled || d(t, i);
    }
    function R(t) {
      const {
        tmNode: i
      } = n, {
        value: v
      } = f;
      i.disabled || v || d(t, i);
    }
    return {
      multiple: u,
      isGrouped: M(() => {
        const {
          tmNode: t
        } = n, {
          parent: i
        } = t;
        return i && i.rawNode.type === "group";
      }),
      showCheckmark: b,
      nodeProps: k,
      isPending: f,
      isSelected: M(() => {
        const {
          value: t
        } = o, {
          value: i
        } = u;
        if (t === null)
          return !1;
        const v = n.tmNode.rawNode[p.value];
        if (i) {
          const {
            value: C
          } = h;
          return C.has(v);
        } else
          return t === v;
      }),
      labelField: m,
      renderLabel: r,
      renderOption: s,
      handleMouseMove: R,
      handleMouseEnter: a,
      handleClick: e
    };
  },
  render() {
    const {
      clsPrefix: n,
      tmNode: {
        rawNode: o
      },
      isSelected: l,
      isPending: u,
      isGrouped: h,
      showCheckmark: r,
      nodeProps: s,
      renderOption: m,
      renderLabel: p,
      handleClick: b,
      handleMouseEnter: k,
      handleMouseMove: N
    } = this, d = j(l, n), f = p ? [p(o, l), r && d] : [O(o[this.labelField], o, l), r && d], e = s == null ? void 0 : s(o), a = c("div", Object.assign({}, e, {
      class: [`${n}-base-select-option`, o.class, e == null ? void 0 : e.class, {
        [`${n}-base-select-option--disabled`]: o.disabled,
        [`${n}-base-select-option--selected`]: l,
        [`${n}-base-select-option--grouped`]: h,
        [`${n}-base-select-option--pending`]: u,
        [`${n}-base-select-option--show-checkmark`]: r
      }],
      style: [(e == null ? void 0 : e.style) || "", o.style || ""],
      onClick: g([b, e == null ? void 0 : e.onClick]),
      onMouseenter: g([k, e == null ? void 0 : e.onMouseenter]),
      onMousemove: g([N, e == null ? void 0 : e.onMousemove])
    }), c("div", {
      class: `${n}-base-select-option__content`
    }, f));
    return o.render ? o.render({
      node: a,
      option: o,
      selected: l
    }) : m ? m({
      node: a,
      option: o,
      selected: l
    }) : a;
  }
});
export {
  H as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/select-menu/src/SelectOption.js
// module id = 1564
// module chunks = 41